import { generateFormData } from "../helpers/form_data_generator";
import {
  addUnlockIcon,
  getProjectData,
  renderProject,
  showFilePreviewAndFilesUploaded,
} from "../helpers/project_data";
import {
  debounce,
  post_data,
  transferValuesToCopyForm,
  transferValuesToCopyFormForCheckboxAndSelectFields,
  isCheckboxSpan,
  toggleChecboxCheck,
  setContainerBackgroundColor,
  getUploadedFilesFormData,
  showCopyFormAndSketchPreview,
  showUploadedFileNames,
  showNotification,
  showAditionalFilePreview,
  removeAditionalImagePreview,
} from "../helpers/functions";
import toastr_show from "../helpers/toastr_options";
import { Fabric } from "../classes/fabric";
import { Yarn } from "../classes/yarn";
import { customSelect } from "../classes/custom_select";
import { unlockProject } from "../helpers/unlock_project";
import Uploader from "../classes/uploader";
// prettier-ignore
import { createVersionDropdown, selectProjectType, toggleDropdown, toggleSelectProjectDropdown } from "../helpers/editor_dropdown";
import { Sequins } from "../classes/sequins";
// prettier-ignore
import { requiredFieldsPopulated, showErrors } from "../helpers/check_required_fields";
import Modal from "../classes/modal";
import { getDataForPublishing } from "../helpers/get_publish_data";
import { publishFormData } from "../helpers/publish_form";
import {
  removeEditorReadOnlyFlag,
  setEditorToReadOnly,
} from "../helpers/editor_readonly";
import { removeReadonlyFlag } from "../helpers/remove_readonly_flag";
import { changeProjectVersion } from "../helpers/change_project_version";
import {
  checkImageCreation,
  createIframeForImageCreation,
} from "../helpers/image_creation";
import {
  checkPDFCreation,
  createIframeForPDFCreation,
} from "../helpers/pdf_creation";
import {
  checkCustomSelectFields,
  selectedDesignType,
} from "../helpers/check_custom_select_fields";
import {
  checkMaterialRows
} from "../helpers/check_yarns_sequins_fields";
export default async function editor_page() {

  // Flag so know are we already saving the data
  let savingProject = false;

  if (window.location.href.indexOf("/editor") === -1) return;
  let savedData = true;

  document.querySelector(".loader").classList.add("active");

  const dropArea = document.querySelectorAll(".upload-container");
  const fileInput = document.querySelectorAll(
    "#fileInput, #fileInputForm, #fileInputAddition"
  );

  // Prevent default behavior when files are dragged over the drop area
  dropArea.forEach((area) =>
    area.addEventListener("dragover", (e) => {
      e.preventDefault();
      area.classList.add("active");
    })
  );

  // Revert styles when files are dragged out of the drop area
  dropArea.forEach((area) =>
    area.addEventListener("dragleave", () => {
      area.classList.remove("active");
    })
  );

  const handleTIFFFile = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const ifds = UTIF.decode(arrayBuffer);
    UTIF.decodeImage(arrayBuffer, ifds[0]); // Decode the first IFD (Image File Directory)
    const firstPage = ifds[0];
    const rgba = UTIF.toRGBA8(firstPage);
  
    // Check if width and height are valid numbers
    if (isNaN(firstPage.width) || isNaN(firstPage.height)) {
      throw new Error('Invalid width or height in TIFF image.');
    }
  
    // Create a canvas to render the TIFF as an image
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const imgData = ctx.createImageData(firstPage.width, firstPage.height);
    imgData.data.set(rgba);
    canvas.width = firstPage.width;
    canvas.height = firstPage.height;
    ctx.putImageData(imgData, 0, 0);
  
    // Convert canvas to a Blob
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(new File([blob], file.name.replace(/\.tiff?$/i, '.png'), { type: 'image/png' }));
      }, 'image/png');
    });
  };
  


  // Handle dropped files to the whole app (three fields: main, additional, additional documents)
  dropArea.forEach((area) => {
    area.addEventListener("drop", async (e) => {

      e.preventDefault();
      const files = e.dataTransfer.files;
      const dT = new DataTransfer();
  
      for (const file of files) {
        if (file.type === 'image/tiff' || file.name.toLowerCase().endsWith('.tif') || file.name.toLowerCase().endsWith('.tiff')) {
          try {
            const convertedFile = await handleTIFFFile(file);
            dT.items.add(convertedFile);
          } catch (error) {
            console.error('Error processing TIFF file:', error);
          }
        } else {
          dT.items.add(file);
        }
      }
  
      // Find the closest parent element that matches the drop zone
      const dropZone = e.target.closest('.upload-container');
      const fileInput = dropZone.querySelector('input[type="file"]');

      // Create a new DataTransfer object
      const mergedDataTransfer = new DataTransfer();

      // Add the existing files from fileInput to the DataTransfer object
      for (let i = 0; i < fileInput.files.length; i++) {
          mergedDataTransfer.items.add(fileInput.files[i]);
      }

      // Add the new files from dT to the DataTransfer object
      for (let i = 0; i < dT.files.length; i++) {
          mergedDataTransfer.items.add(dT.files[i]);
      }

      // Assign the merged files to fileInput
      fileInput.files = mergedDataTransfer.files;

      
      // Main image
      if (dropZone.id === "upload-main-image") {

        showCopyFormAndSketchPreview(dT.files);
      
      // Additional files
      } else if (dropZone.classList.contains("upload-container--form")) {

        let duplicateFiles = showUploadedFileNames(dT.files); // Get the array of duplicate file names

        if (duplicateFiles && duplicateFiles.length > 0) {

          duplicateFiles.forEach((fileName) => {
            toastr_show("error", `File "${fileName}" is already listed and will be ignored.`);
          });

        }

        dropZone.classList.remove("active");
      
      // Additional image
      } else if (dropZone.id === "upload-main-image-addition") {

        showAditionalFilePreview(dT.files);

      }
    });
  });
  

// Persistent array to store all selected files
let allSelectedFiles = [];

fileInput.forEach((fileInputLabel) => {
  // Clear the input on click to ensure that selecting the same file triggers the change event
  fileInputLabel.addEventListener("click", (e) => {
    e.target.value = ''; // Reset file input
  });

  fileInputLabel.addEventListener("change", async (e) => {

    const newFiles = Array.from(e.target.files); // Convert FileList to array
    const dT = new DataTransfer();
    let newlySelectedFiles = [];

    // Handle file replacement for "fileInput" and "fileInputAddition"
    if (e.target.id === "fileInput" || e.target.id === "fileInputAddition") {
      // Only keep the most recent file (replace the current file)
      const newFile = newFiles[0]; // There's only one file in these inputs
      
      // Handle TIFF conversion if necessary
      if (newFile.type === 'image/tiff' || newFile.name.toLowerCase().endsWith('.tif') || newFile.name.toLowerCase().endsWith('.tiff')) {
        try {
          const convertedFile = await handleTIFFFile(newFile);
          dT.items.add(convertedFile);
        } catch (error) {
          console.error('Error processing TIFF file:', error);
        }
      } else {
        dT.items.add(newFile); // Add the single file
      }

      // Assign the single file to the input
      e.target.files = dT.files;

      // Call preview functions based on the input type
      if (e.target.id === "fileInput") {
        showCopyFormAndSketchPreview(dT.files);
      } else if (e.target.id === "fileInputAddition") {
        showAditionalFilePreview(dT.files);
      }

    } else {
      // For all other inputs, accumulate files in allSelectedFiles (with duplicate check)
      newFiles.forEach(newFile => {
        // Normalize file name by making it case-insensitive
        const normalizedNewFileName = newFile.name.toLowerCase();

        // Check if the file already exists in allSelectedFiles by comparing both name and size
        const isDuplicate = allSelectedFiles.some(existingFile =>
          existingFile.name.toLowerCase() === normalizedNewFileName && existingFile.size === newFile.size
        );

        // Only add non-duplicate files
        if (!isDuplicate) {
          allSelectedFiles.push(newFile); // Add non-duplicate files to allSelectedFiles
          newlySelectedFiles.push(newFile); // Also add to the newly selected files list
        }
      });

      // Rebuild DataTransfer with all unique files (existing + new)
      for (const file of allSelectedFiles) {
        if (file.type === 'image/tiff' || file.name.toLowerCase().endsWith('.tif') || file.name.toLowerCase().endsWith('.tiff')) {
          try {
            const convertedFile = await handleTIFFFile(file); // Handle TIFF conversion
            dT.items.add(convertedFile);
          } catch (error) {
            console.error('Error processing TIFF file:', error);
          }
        } else {
          dT.items.add(file); // Add regular files
        }
      }

      // Assign the combined file list back to the input (allSelectedFiles)
      e.target.files = dT.files;

      // Check for duplicates and call showUploadedFileNames if there are new files
      if (newlySelectedFiles.length > 0) {
        let duplicateFiles = showUploadedFileNames(newlySelectedFiles); // Only pass newly selected files

        // Check and notify about duplicates
        if (duplicateFiles && duplicateFiles.length > 0) {
          duplicateFiles.forEach((fileName) => {
            toastr_show("error", `File "${fileName}" is already listed and will be ignored.`);
          });
        }
      }
    }
  });
});

/* Copy paste from Photoshop or other editor to the DSP */
document.addEventListener('paste', (event) => {
  const loader = document.querySelector(".loader");
  
  // Check if the loader element is found
  if (!loader) {
      console.error("Loader element not found");
      return;
  }

  // Add the 'active' class to show the loader
  loader.classList.add("active");

  const clipboardItems = event.clipboardData.items;
  const dT = new DataTransfer();
  let isProcessing = false;  // A flag to track processing

  for (const item of clipboardItems) {
      if (item.type.startsWith('image/')) {
          isProcessing = true;
          const blob = item.getAsFile();
          const reader = new FileReader();

          reader.onload = function (event) {
              const imgElement = new Image();
              imgElement.src = event.target.result;

              imgElement.onload = function () {
                  const canvas = document.createElement('canvas');
                  const ctx = canvas.getContext('2d');
                  canvas.width = imgElement.width;
                  canvas.height = imgElement.height;
                  ctx.drawImage(imgElement, 0, 0);

                  canvas.toBlob((blob) => {
                      const file = new File([blob], 'pasted-image.png', { type: 'image/png' });
                      dT.items.add(file);

                      // Find the specific main image drop zone
                      const dropZone = document.getElementById('upload-main-image');
                      if (dropZone) {
                          const fileInput = dropZone.querySelector('input[type="file"]');
                          fileInput.files = dT.files;
                          showCopyFormAndSketchPreview(dT.files);
                      }

                      // After processing, remove the loader
                      loader.classList.remove("active");
                  }, 'image/png');
              };
          };

          reader.readAsDataURL(blob);
      }
  }

  // If no image was found in clipboard, hide the loader immediately
  if (!isProcessing) {
      loader.classList.remove("active");
  }
});




  

  // check get params
  const url = new URL(window.location.href);
  let projectId = url.searchParams.get("project");
  // const projectData = await getProjectData(id);
  let folderName;
  const modal = new Modal();
  // handle yarn creation
  const fabricContainer = document.querySelector("#fabric-container");
  const yarnContainer = document.querySelector("#yarn-container");
  const sequinsContainer = document.querySelector("#sequins-container");
  const fabric = new Fabric(1, fabricContainer);
  const yarn = new Yarn(1, yarnContainer);
  const sequins = new Sequins(1, sequinsContainer);

  if (projectId) {
    // prettier-ignore
    const [projectData, yarnData, fabricData, sequinsData, projectFiles] = await getProjectData(projectId);
    // prettier-ignore
    if (projectData.status === "locked") return showNotification('error', "Someone allready editing project");
    renderProject(projectData);
    showFilePreviewAndFilesUploaded(projectData.image_path, projectFiles);
    yarn.setData(yarnData);
    fabric.setData(fabricData);
    sequins.setData(sequinsData);
    customSelect.setDataToFields(projectData);
    window.addEventListener("beforeunload", unlockProject);
    folderName = projectData.image_path;
    createVersionDropdown(
      projectData.number_of_versions,
      projectData.current_version
    );
    if (document.getElementById("double-thread").checked)
      yarn.showDoubleThreadInput();
    if (projectData.status === "9") {
      // status 9 means project is published
      setEditorToReadOnly();
      showNotification(
        "success",
        "The project has already been published and is currently set to read-only mode.",
        5000
      );
    }
  } else {
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 16);
    document.getElementById("date").value = formattedDate;
    folderName = Date.now();
    folderName = folderName.toString();
    const url = new URL(window.location.href);
    const projectName = url.searchParams.get("name");
    document.getElementById("project-name").textContent = projectName;
  }

  fabric.renderFields();
  yarn.renderFields();
  sequins.renderFields();

  fabric.addValuesToFields();
  yarn.addValuesToFields();
  sequins.addValuesToFields();
  sequins.updatePositions();

  document.querySelector(".loader").classList.remove("active");

  const uploader = new Uploader();

  document.addEventListener("click", async (e) => {
    e.stopImmediatePropagation();

    if (e.target.classList.contains("custom-select-option")) {
      savedData = false;
    }
    // prettier-ignore
    if (e.target.id !== 'selectedVersion') {
      document.querySelector(".dropdown-content.show")?.classList.remove("show");
      document.querySelector('.dropdown__selected-item').textContent = document.querySelector('.dropdown__selected-item').textContent.split(' (Cu')[0];
    }

    // hide custom select options
    if (
      !e.target.classList.contains("custom-select-option") &&
      !e.target.classList.contains("editor-form__custom-select")
    ) {
      customSelect.focusSelectOut(e);
    }

    // remove modalto-home-page
    if (
      e.target.classList.contains("modal-overlay") ||
      e.target.classList.contains("modal__close")
    ) {
      e.preventDefault();
      document.querySelector(".modal")?.parentElement.remove();
      if (
        e.target.classList.contains("to-home-page") &&
        e.target.classList.contains("modal__close")
      ) {
        setTimeout(() => {
          window.location.href = "./projects";
        }, 1000);
      }
    }

    if (isCheckboxSpan(e)) {
      // Handle checkbox
      toggleChecboxCheck(e.target);
      if (e.target.id === "double-thread-span") {
        const checkbox = e.target.parentElement.querySelector("input");
        if (checkbox.checked) yarn.showDoubleThreadInput();
        else yarn.hideDoubleThreadInput();
      }
    } else if (
      e.target.parentElement.id === "save" ||
      e.target.id === "save-form"
    ) {

      // Show notification for saving the project
      showNotification("success", "Saving project ...");
      // If we are already saving the project then just return and wait
      if(savingProject){
        return;
      }

      savingProject = true;

      document.querySelector(".loader").classList.add("active");

      // Handle saving data
      if (!checkCustomSelectFields()){
        document.querySelector(".loader").classList.remove("active");
        savingProject = false;
        return;
      }

      if (!checkMaterialRows()){
        document.querySelector(".loader").classList.remove("active");
        savingProject = false;
        return;
      }

      const isSavedSuccessfully = await saveFormData(folderName);
      if (!isSavedSuccessfully){
        document.querySelector(".loader").classList.remove("active");
        return;
      }

      if (!projectId) {
        url.searchParams.delete("name");
        url.searchParams.set("project", isSavedSuccessfully);
        projectId = isSavedSuccessfully;
        history.pushState({}, null, url.toString());
      }

      document.querySelector(".modal")?.parentElement.remove();
      savedData = true;
      changeProjectVersion();

      savingProject = false;

      if (e.target.classList.contains("to-home-page")) {
        setTimeout(() => {
          window.location.href = "./projects";
        }, 1000);
      }

      document.querySelector(".loader").classList.remove("active");

    } else if (e.target.id === "remove-additional-image") {
      modal.displayDeleteAdditionalImageModal();
    } else if(e.target.id === "remove-additional-image-button") {
      removeAditionalImagePreview();
      document.querySelector(".modal")?.parentElement.remove();
    } else if (e.target.id === "unlock") {
      removeReadonlyFlag();
      removeEditorReadOnlyFlag();
      showNotification("success", "Project successfully unlocked.");
      setTimeout(() => e.target.parentElement.remove(), 1000);
    } else if (e.target.id === "back") {
      if (savedData) return;
      e.preventDefault();
      modal.displayLeavingEditorModal(e, true);
      savedData = true;
    } else if (e.target.getAttribute("data-remove") === "yarn") {
      savedData = false;
      yarn.removeField(e);
      sequins.updatePositions(e);
    } else if (e.target.id === "add-yarn") {
      savedData = false;
      yarn.addField();
      // prettier-ignore
    } else if (e.target.getAttribute("data-remove") === "fabric") {
      savedData = false;
      fabric.removeField(e);
    } else if (e.target.id === "add-fabric") {
      savedData = false;
      e.preventDefault();
      fabric.addField();
    } else if (e.target.id === "add-sequins") {
      savedData = false;
      sequins.addField();
    } else if (e.target.getAttribute("data-remove") === "sequins") {
      savedData = false;
      sequins.removeField(e);
    } else if (e.target.classList.contains("custom-select-option")) {
      customSelect.selectItem(e.target);
    } else if (e.target.classList.contains("remove-file")) {
      uploader.toggleFileDeleteModal(e);
    } else if (e.target.classList.contains("modal__delete")) {
      e.preventDefault();
      document.querySelector(".modal")?.parentElement.remove();
      if (projectId) {
        const response = await uploader.deleteFileButton(e);
        if (response.status !== "success") {
          return showNotification("error", response.msg);
        }
      }
      uploader.updateUplaodedFiles();
    } else if (e.target.id === "selectedVersion") {
      toggleDropdown(e);
    } else if (e.target.classList.contains("dropdown__item")) {
      // prettier-ignore
      const newLocation = location.href.split("&")[0] + "&version=" + e.target.textContent.split(" ")[1];
      history.pushState({}, null, newLocation);
      // prettier-ignore
      location.reload();
    } else if (e.target.id === "export") {
      if (!checkCustomSelectFields()) return;
      const currentProjectId = await saveFormData(folderName, true);
      // prettier-ignore
      const exportLocation = location.href.split('editor')[0] + 'pdf-document.php?id=' + currentProjectId + '&version=0';
      window.open(exportLocation, "_blank", "noopener,noreferrer");
    } else if (e.target.id === "publish") {
      if (!checkCustomSelectFields()) return;
      if (!checkMaterialRows()) return;
      const errorArray = requiredFieldsPopulated();
      if (errorArray.length > 0) {
        return showErrors(errorArray);
      }
      modal.displayProjectTypeModal();
    } else if (e.target.classList.contains("publish")) {
      if (!checkCustomSelectFields()) return;
      if (!checkMaterialRows()) return;
      if (!selectedDesignType()) {
        return showNotification("error", "Please select a design type.");
      }
      const savedDataToDb = await saveFormData(folderName);
      if (!savedDataToDb) return;
      if (!projectId) {
        url.searchParams.delete("name");
        url.searchParams.set("project", savedDataToDb);
        projectId = savedDataToDb;
        history.pushState({}, null, url.toString());
      }
      changeProjectVersion();
      const values = getDataForPublishing(e.target);
      const response = await publishFormData(values);

      // If error is a show stopper then stop execution
      if (response.status === "error" && !response.execution) {
        return showNotification("error", response.message, 10000);
      }

      setEditorToReadOnly();
      addUnlockIcon();

      if(response.status !== "error" && !response.execution){
        showNotification(
          "success",
          "Successfully published project.",
          5000
        );
      }
      

      // If error is not a show stopper then don't stop execution
      if(response.status === "error" && response.execution && response.execution == "continue"){
        showNotification("error", response.message, 10000);
      }
      
      showNotification(
        "success",
        "Creating image...",
        10000
      );

      // create iframe and start creating Image
      createIframeForImageCreation(projectId);
      const isImageCreated = await checkImageCreation(
        response.array["dessinnr"]
      );
      if (isImageCreated.status === "error") {
        showNotification("error", isImageCreated.message);
      }else{
        showNotification("success", "Image created successfully.");
      }

      // remove iframe and start creating PDF
      document.querySelector("iframe").remove();
      showNotification(
        "success",
        "Creating PDF...",
        10000
      );

      createIframeForPDFCreation(projectId);
      const isPDFCreated = await checkPDFCreation(
        response.array["dessinnr"]
      );
      if (isPDFCreated.status === "error") {
        showNotification("error", isPDFCreated.message);
      }else{
        showNotification("success", "PDF created successfully.");
      }

      // remove iframe
      document.querySelector("iframe").remove();

    } else if (e.target.classList.contains("dropdown-select__selected-item")) {
      toggleSelectProjectDropdown();
    } else if (e.target.classList.contains("dropdown-select__item")) {
      selectProjectType(e);
      toggleSelectProjectDropdown();
    }  else if (e.target.classList.contains("cutcrop-modal")) {
      
      const imageElement = document.querySelector(".image-preview");
      const imageUrl = imageElement ? imageElement.src : null;
      if (imageUrl) {
          modal.displayCutCropModal(imageUrl); // Pass the image URL to the modal
      }
      
    }
  });

  const customSelectFields = document.querySelectorAll(
    ".editor-form__custom-select"
  );
  customSelectFields.forEach((field) => {
    field.addEventListener("focus", (e) => {
      customSelect.focusSelect(e);
    });
  });

  const lists = document.querySelectorAll(".custom-select-list");
  lists.forEach((list) => {
    customSelect.addScrollEventToObject(list.parentElement);
  });

  // Transfer values from form to copy form
  const editorForm = document.querySelector(".editor-content__form");
  const debounceInput = debounce(transferValuesToCopyForm, 200);
  const debounceSearchInput = debounce(customSelect.fetchItems, 300);
  editorForm.addEventListener("input", (e) => {
    savedData = false;
    if (e.target.classList.contains("editor-form__custom-select")) {
      debounceSearchInput(e);
    } else if (e.target.id?.includes("sequins")) {
      sequins.updatePositions(e);
    } else if (e.target.id?.includes("yarn")) {
      yarn.renderCopyFields(e);
    } else if (
      e.target.type === "text" ||
      e.target.type === "number" ||
      e.target.tagName.toLowerCase() === "textarea"
    ) {
      debounceInput(e);
    }
  });
  editorForm.addEventListener("change", (e) => {
    savedData = false;
    if (e.target.type === "color") setContainerBackgroundColor(e);
    else if (e.target.type === "checkbox")
      transferValuesToCopyFormForCheckboxAndSelectFields(e);

    // check double thread change to update yarn
    if (e.target.id === "double-thread") {
      if (e.target.checked) yarn.showDoubleThreadInput();
      else yarn.hideDoubleThreadInput();
    }
  });

  document.addEventListener("keydown", (e) => {
    customSelect.handleKeyPress(e);
  });

  // check if user is leaving page
  document.addEventListener("mouseleave", (e) => {
    //do some async code
    // Turn it of for now
    /* if (savedData) return;
    if (e.clientY <= 0) {
      modal.displayLeavingEditorModal(e);
      savedData = true;
    } */
  });
}


// Function which saves all data from the form, including files
async function saveFormData(folderName, saveForExport = false) {

  const uploadFormData = await getUploadedFilesFormData(folderName);

  const form = document.querySelector("form");
  const formData = await generateFormData(form, folderName, saveForExport);

  const folderResponse = await post_data(
    "./includes/ajax.inc.php",
    uploadFormData
  );

  if (folderResponse["status"] === "error") {
    showNotification("error", folderResponse["message"]);
    return false;
  }

  const dataResponse = await post_data("./includes/ajax.inc.php", formData);
  if (dataResponse["status"] === "error") {
    showNotification("error", dataResponse["message"]);
    return false;
  }
  if (saveForExport) return dataResponse.id;
  showNotification("success", dataResponse.message);
  return dataResponse.id ?? true;

}



document.querySelectorAll('.editor-form__custom-select').forEach(input => {
  input.addEventListener('blur', function(e) {
    if (input.id === "series") return; // <-- allow free text for #series
    const allowed = input.allowedNames || [];
    if (!allowed.includes(input.value)) {
      input.value = "";
      input.removeAttribute('data-id');
    }
  });
});
